import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		redirect: '/workflows',
	},
	{
		path: '/workflows',
		name: 'Home',
		component: Home,
		props: (route) => ({
			application: route.query.application,
			analyte: route.query.analyte,
			startingMaterial: route.query.startingMaterial,
			technology: route.query.technology,
		}),
	},
	{
		path: '/workflows/:application/:startingMaterial/:analyte/:technology',
		name: 'Workflow',
		props: true,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "workflow" */ '../views/Workflow.vue'),
	},
	{
		path: '/workflows/*',
		component: () => import(/* webpackChunkName: "workflow" */ '../views/Workflow.vue'),
	},
	{
		path: '/shared/*',
		name: 'Shared',
		props: (route) => ({
			application: '*',
			analyte: '*',
			startingMaterial: '*',
			technology: '*',
		}),
		component: () => import(/* webpackChunkName: "workflow" */ '../views/Workflow.vue'),
	},
	{
		path: '/myqiagen',
		name: 'MyQiagen',
		beforeEnter() {
      location.href = `https://${window.location.hostname}/myqiagen/`
		}
	},
	{
		path: '/myWorkflows',
		name: 'MyWorkflows',
		props: true,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "workflow" */ '../views/MyWorkflows.vue'),
	},
	{
		// catch all
		path: '/*',
		redirect: '/workflows',
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		// native-like behavior when navigating with back/forward buttons
		if (savedPosition) return savedPosition;

		// scroll to anchor
		if (to.hash) return {selector: to.hash, behavior: 'smooth'};

		// stop scroll for open/close modal
		if (to.query?.modal || from.query?.modal) return;

		if (to.name === from.name) return;
		// default scroll to top
		return {x: 0, y: 0};
	},
});

export default router;
